import * as Updates from 'expo-updates';
import { Platform } from 'react-native';
import Constants from 'expo-constants';

// Allow a local Release build to emulate the EAS production channel for crash repro.
// EXPO_PUBLIC_CHANNEL overrides the native Updates.channel at runtime so the
// production code paths execute against a local Release build (see scripts/local-prod-test.sh).
const effectiveChannel = process.env.EXPO_PUBLIC_CHANNEL || Updates.channel;
const forceProd = process.env.EXPO_PUBLIC_FORCE_PROD === '1';

const expoExtra = Constants?.expoConfig?.extra ?? {};

let Config = {
  apiUrl: expoExtra.apiUrl || 'https://192.168.1.193:4000',
  webApi: __DEV__ ? (expoExtra.webApi || 'https://api.smartsaas.pro') : 'https://api.smartsaas.pro',
  aiAPI: __DEV__ ? (Platform.OS === 'web' ? "https://localhost:11435" : "http://192.168.1.133:11435") : "https://ai.smartsaas.pro:11437",
  aiChatAPI: __DEV__ ? (Platform.OS === 'web' ? "http://localhost:11434" : "http://192.168.1.133:11434") : "https://ai.smartsaas.pro:11436",
  enableHiddenFeatures: false,
  appStoreSecret: '35322a6bc5274befa6ca622ff79be5db'
};

if (effectiveChannel === 'production' || forceProd) {
  Config.apiUrl = 'https://api.smartsaas.pro';
  Config.webApi = 'https://api.smartsaas.pro';
  Config.enableHiddenFeatures = false;
} else if (effectiveChannel === 'staging') {
  Config.apiUrl = 'https://smartsaas-backend-staging-530616870665.us-central1.run.app';
  Config.enableHiddenFeatures = true;
}

// ✨ Configure logging based on environment
// Disables console logging in production mode, especially for web
export const configureProductionLogging = () => {
  const isWebProduction = Platform.OS === 'web' && !__DEV__;
  const isNativeProduction = effectiveChannel === 'production' || (!__DEV__ && Platform.OS !== 'web');
  const isProduction = isWebProduction || isNativeProduction;

  // EXPO_PUBLIC_KEEP_LOGS=1 keeps console.* alive in Release builds so you can
  // capture the real Hermes stack trace when reproducing prod crashes locally.
  const keepLogs = process.env.EXPO_PUBLIC_KEEP_LOGS === '1';

  if (isProduction && !keepLogs) {
    const noop = () => {};
    console.log = noop;
    console.info = noop;
    console.debug = noop;
    console.trace = noop;
    console.warn = noop;
    console.error = noop;
  }
};

export default Config;